// src/contexts/AuthContext.js
import React, { createContext, useState } from 'react';
import {jwtDecode as jwt_decode} from 'jwt-decode';
const AuthContext = createContext();
export const AuthProvider = ({ children }) => {

  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem('token');
    return storedToken || null;
  });
  
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem('token');
    if (token) {
      return jwt_decode(token);
    }
    return null;
  });
  const login = (token) => {
    localStorage.setItem('token', token);
    setUser(jwt_decode(token));
    setToken(token);
  };
  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };
  return (
    <AuthContext.Provider value={{ token, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
export default AuthContext;